import { getSurfLayout, isKnownLayoutId } from "./templates.js";
/** Max bullet lines the Designer should place on one slide (F21). */
export const SURF_MAX_BULLETS_PER_SLIDE = 5;
const ROLE_LAYOUT_PRIORITY = {
    cover: ["cover"],
    section: ["section"],
    summary: ["section", "bullets"],
    agenda: ["bullets", "two-column"],
    content: ["bullets", "title-body", "two-column", "image-left"],
    comparison: ["comparison", "two-column"],
    data: ["big-number", "bullets", "title-body"],
    quote: ["quote"],
    cta: ["closing", "cover"],
};
export function suggestLayoutsForSlide(slide) {
    const role = (slide.outlineRole ?? "").toLowerCase();
    const hinted = slide.layoutHint?.trim();
    const suggestions = new Set();
    if (hinted && isKnownLayoutId(hinted)) {
        suggestions.add(hinted);
    }
    for (const id of ROLE_LAYOUT_PRIORITY[role] ?? []) {
        suggestions.add(id);
    }
    const visual = slide.outlineVisual?.kind;
    if (visual === "image" || visual === "graphic") {
        suggestions.add("image-left");
    }
    if (visual === "chart" || visual === "table") {
        suggestions.add("bullets");
        suggestions.add("title-body");
    }
    const bulletLayers = slide.layers.filter((l) => l.textRole === "bullet").length;
    const bulletText = slide.layers
        .filter((l) => l.textRole === "bullet" || l.style?.slotRole === "bullets")
        .some((l) => (l.content.match(/\n/g)?.length ?? 0) >= 2);
    if (bulletLayers >= 2 || bulletText) {
        suggestions.add("bullets");
    }
    if (!suggestions.size) {
        suggestions.add("bullets");
        suggestions.add("title-body");
        suggestions.add("two-column");
    }
    return [...suggestions].filter((id) => Boolean(getSurfLayout(id)));
}
export function designerRoleGuidance(slide) {
    const role = (slide.outlineRole ?? "content").toLowerCase();
    const lines = [
        `Outline role: ${role}.`,
        `Suggested layouts (pick the best ONE): ${suggestLayoutsForSlide(slide).join(", ")}.`,
        "One idea per slide — short title, concise slots.",
        `Bullets: max ${SURF_MAX_BULLETS_PER_SLIDE} lines, parallel phrasing, no walls of text.`,
        "Avoid title-body unless the slide is a single short paragraph with no list.",
    ];
    if (role === "data") {
        lines.push("Prefer big-number when a statistic or KPI is present; put the number in the number slot.");
    }
    if (role === "quote") {
        lines.push("Use quote layout; citation in attribution slot.");
    }
    if (role === "comparison") {
        lines.push("Use comparison layout; split pros/cons into option_a and option_b.");
    }
    if (role === "cover" || role === "cta") {
        lines.push("Use cover or closing layout — minimal copy, strong headline.");
    }
    return lines;
}
